<template>
  <a-modal
    :keyboard="false"
    :maskClosable="false"
    :width="'830px'"
    :title="title"
    :visible="projectOperVisible"
    :centered="true"
    :bodyStyle="{ 'padding-left': 0, 'padding-bottom':0 }"
    dialogClass="logger-dialog"
    wrapClassName="logger-dialog-mask"
    @cancel="closeModal"
  >
    <div class="mask-loading" v-if="loading">
      <div class="tip">
        <a-spin size="large" />
      </div>
    </div>
    <a-form-model class="form" ref="ruleForm" :model="form" :rules="rules" v-bind="formItemLayout">
      <a-form-model-item class="logger-form-tips" :label="$t('project.templateName')" prop="name">
        <a-textarea
          :disabled="isCanEdit"
          v-model="form.name"
          ref="input"
          class="logger-input noresize"
          :rows="3"
          :placeholder="$t('project.templateNameRules',[30])"
          :maxLength="30"
          spellcheck="false"
        ></a-textarea>
        <!-- <span class="form-item-tips">{{ form?.name?.length }}/30</span> -->
        <!-- <div style="line-height: normal; color: #a5a7b5; font-size: 12px; margin-top: 4px">
          模板名称后续不可更改,谨慎填写
        </div> -->
      </a-form-model-item>
      <a-form-model-item :label="$t('project.industry')" prop="industry" class="hy">
        <a-select
          :disabled="isCanEdit"
          dropdownClassName="logger-select-prop"
          class="logger-select"
          :placeholder="$t('project.industryPlaceholder')"
          v-model="form.industry"
        >
          <a-select-option v-for="d in industryList" :key="d.value">
            {{ d.name }}
          </a-select-option>
        </a-select>
        <!-- <div style="line-height: normal; color: #a5a7b5; font-size: 12px; margin-top: 6px">
          行业类别后续不可更改,谨慎填写
        </div> -->
      </a-form-model-item>
      <a-form-model-item :label="$t('project.version')">
        <div class="extra-input">
          <div>
            <a-select
              v-if="isShowHistoryVersion"
              style="width: 200px"
              dropdownClassName="logger-select-prop"
              class="logger-select"
              placeholder="请选择版本"
              v-model="form.coverVersion"
            >
              <a-select-option v-for="d in versionList" :key="d"> V{{ d }} </a-select-option>
            </a-select>
            <div class="cover-version" v-else>V{{ form.version }}</div>
          </div>
          <div class="cover-history" style="margin-left: 20px">
            <a-checkbox  v-model="isCoverVersion" @change="handleCoverHistory">
              <span style="color: #a2a5ae">{{$t('project.overwriteHistoricalVersion')}}</span>
            </a-checkbox>
          </div>
          <!-- <div class="m-integral" style="margin-left: 20px">
            <span class="jf" style="width: 60px; text-align: left; line-height: 30px; display: inline-block;color: #a2a5ae">{{$t('project.integral')}}</span>
            <a-input
              :disabled="true"
              style="width: 264px; background: #313132; color: #fff"
              spellcheck="false"
              ref="input"
              @input="replaceSpecialChars"
              class="logger-input"
              v-model="form.score"
              oninput="value=value.replace(/[^\d]/g,'')"
              :placeholder="$t('project.integral')"
            />
          </div> -->
        </div>
      </a-form-model-item>

      <a-form-model-item :label="$t('project.introduction')" prop="remark">
        <a-textarea
          v-model="form.remark"
          class="logger-input noresize"
          :rows="4"
          :placeholder="$t('project.templateIntroductionRules',[200])"
          spellcheck="false"
          :maxLength="200"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('project.projectCover')" prop="coverUrl">
        <ul class="upload-container no-select">
          <li class="upload-item upload-item-img">
            <a-icon v-if="form.coverUrl" type="close" class="cursor-pointer" @click="handleDelUploadImg" />
            <img :src="getImageURL(form.coverUrl)" alt="" />
            <span class="default-cover" v-if="!form.coverUrl">{{$t('project.defaultCover')}}</span>
          </li>
          <a-upload
            list-type="picture-card"
            :show-upload-list="false"
            :custom-request="customRequest"
            :before-upload="beforeUpload"
          >
            <li class="upload-item upload-item-handle not-allow-user-select cursor-pointer">
              <!-- <a-icon :type="loading ? 'loading' : 'plus'" /> -->
              <a-icon type="plus" class="addIconClass" />
              <!-- <p>自定义上传</p> -->
            </li>
          </a-upload>
          
          <li class="upload-item-tips">
            <p>{{$t('project.uploadImageTip',['5M'])}}</p>
            <p>{{$t('project.suggestedUploadRatio',['16:9','4:3'])}}</p>
            <!-- <p style="color: #f00">当前封面与预览图为同一图片,谨慎上传</p> -->
          </li>
          <div style="clear: both"></div>
        </ul>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <div>
        <a-button class="cancelBtnClass" :disabled="loading" @click="closeForm">取消</a-button>
        <a-button @click="submitForm" :loading="submitLoading" type="primary" style="margin-left: 10px">确定</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import base from '@/api/base'
import { mapGetters, mapActions } from 'vuex'
import defaultCover from '@/assets/images/default_cover.png'
import request from '@/utils/request'
import { publishSand, bicubePublish } from '@/api/workbench'
// import { Modal } from 'ant-design-vue'

export default {
  name: 'TemplateModal',
  props: {
    sandInfo: {
      type: Object,
      default: () => {},
    },
    templateInfo: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    const _this = this
    return {
      showLimit: false,
      projectOperVisible: false,
      versionList:[],
      submitLoading: false,
      form: {
        name: '',
        industry: undefined,
        version: 1,
        coverVersion: null,
        score: 0,
        remark: '',
        coverUrl: '',
      },
      defaultCover,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 19 },
      },
      nowType: 'publishTemplate',
      isCoverVersion: false,
      isShowHistoryVersion: false,
      modalType: '',
      loading: false,
    }
  },
  watch: {
    projectOperVisible(val) {
      if (val) {
        this.$refs?.ruleForm?.resetFields()
        this.isShowHistoryVersion = false
        this.isCoverVersion = false
        this.getSelectAllIndustries()
      }
    },
    templateInfo(val) {
      if(val && Object.keys(val).length){
        this.versionList = val.versionList
        this.form.version = val.version
      }
    }
  },
  computed: {
    ...mapGetters(['industries']),
    industryList(){
      return this.industries
    },
    userInfo() {
      return this.$store.state.account.userInfo
    },
    title() {
      return  this.$t('project.sandboxPublishTemplate') 
    },
    userId() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
      return userInfo.applyAccount || userInfo.userId || null
    },
    modalWidth() {
      return this.nowType == 'publishTemplate' ? '800px' : '60%'
    },
    isPubDzsp() {
      return this.modalType == 'dzsp'
    },
    isCanEdit() {
      return !!this.form.id
    },
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.$t('project.pleaseInputTemplateName'),
            trigger: ['change'],
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[A-Za-z0-9\u4e00-\u9fa5][A-Za-z0-9\u4e00-\u9fa5_]*$/
              reg.test(value) ? callback() : callback(this.$t('project.templateNameRules2'))
            },
          },
        ],
        industry: [
          {
            required: true,
            message: this.$t('project.industryPlaceholder'),
            trigger: ['change'],
          },
        ],
        coverUrl :  [
          {
            required: true,
            message: this.$t('project.pleaseSelectTemplateCover'),
            trigger: ['change'],
          },
        ],
      }
    },
  },
  methods: {
    ...mapActions('workbench',['getSelectAllIndustries']),
    
    checkField(prop) {
      this.$refs?.ruleForm?.validateField?.(prop)
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error(this.$t('project.uploadJpgPng') )
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error(this.$t('project.uploadSizeLimit',['5M']) )
      }
      return isJpgOrPng && isLt5M
    },
        // 自定义上传，可以自定义上传接口，不用通过action属性，还是非常灵活的
    customRequest(file) {

      const form = new FormData()
      form.append('file', file.file)
      form.append('businessType', 'sand_page')
      // form.append('app', 'family')
      this.uploadFile(form)
        .then((res) => {
          this.$refs?.ruleForm?.clearValidate(['coverUrl'])
          this.form.coverUrl = res.data.storagePath
          file.onSuccess(res.data, file.file)
        })
        .catch((err) => {
          this.form.coverUrl = ''
          file.onError()
          file.status = 'error'
          if (err.message != "Cannot read properties of undefined (reading 'status')") {
            this.$message.error(err.message)
          } else {
            this.$message.error('上传超时，请求失败!')
          }
        })
    },
    // 文件上传的api
    uploadFile(parameter) {
      return request({
        url: `${base.api}/motion/base/common/upload`,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: parameter,
        timeout: 1000 * 60 * 10,
      })
    },
    // initParams(d) {
    //   this.isCoverVersion = false
    //   let params = {
    //     id: null,
    //     templateId: null,
    //     coverUrl: '',
    //     viewId: null,
    //     name: '',
    //     sandId: '',
    //     supplier: null,
    //     supplierName: null,
    //     companyCode: null,
    //     projectPath: '',
    //     sandPath: '',
    //     reviewRemark: null,
    //     version: 1,
    //     type: templateTypes[this.modalType],
    //     remark: null,
    //     industry: 3,
    //     sizes: [],
    //     coverVersion: null,
    //     versionList: [],
    //   }
    //   let imgs = {
    //     production: '/family/biCubeMotion/png/defaultCover_20240910155600029.png',
    //     else: '/family/biCubeMotion/png/defaultCover_20250102150200033.png',
    //   }
    //   params.coverUrl = process.env.NODE_ENV == 'production' ? imgs.production : imgs.else
    //   this.$nextTick(() => {
    //     Object.keys(params).forEach((key) => {
    //       let value
    //       if (d?.id) {
    //         value = d[key]
    //       } else {
    //         value = params[key]
    //       }
    //       this.$set(this.form, key, value)
    //     })
    //   })
    // },
    async showDialog() {
      this.projectOperVisible = true
    },
    async getBasePlatformToken() {},
    getList() {
      this.$root?.exportRefresh?.()
    },
    replaceSpecialChars(e) {
      const regexPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/g
      this.form.score = e.target.value.replace(regexPattern, '').trim()
    },


    // 发布电子沙盘模板第一步先进行导出,导出成功之后需要删除
    handleExportDzsp() {},
    handleExportProjectCase() {},
    // async handleUploadTemplate({ compressPath, projectcompressPath }) {},

    async addTemplate() {},

    updateTemplate() {
      this.$message.success('更新成功')
    },

    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // 先从后台获取sandInfoId,然后再发布
          this.publishSand()
        }
      })
    },
    async publishSand() {
      this.submitLoading = true
      const payload = {
        account: this.userId,
        sandId: this.sandInfo.id, // 主键ID
        version: this.form.version,
      }
      try {
        const res = await publishSand(payload)
        if (res.code == 200) {
          this.sendBicubePublish(res.data)
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        this.submitLoading = false
      }
    },
    async sendBicubePublish(sandInfoId){
      try {
        const payload = {
          sandInfoId,
          type: 0,
          templateId: this.sandInfo.sandId,
          visitCode:"", 
          projectPath:"", 
          sandPath: "",
          ...this.form
        }
        const res = await bicubePublish(payload)
        if(res.status === 0){
          this.$message.success('发布成功')
          this.closeModal()
        }
      } catch (error) {
        
      } finally {
        this.submitLoading = false
      }
    },
    // reExport() {
    //   this.handleAdd()
    // },
    closeModal() {
      if (this.loading) {
        return this.$message.info('正在发布中,请等待')
      }
      this.$refs?.ruleForm?.resetFields()
      this.projectOperVisible = false
    },
    closeForm() {
      this.projectOperVisible = false
    },
    // okExport() {
    //   this.projectOperVisible = false
    // },
    getImageURL(coverUrl) {
      return coverUrl ? `${process.env.VUE_APP_CTYUN_URL}${coverUrl}` : this.defaultCover
    },
    handleDelUploadImg() {
      this.form.coverUrl = ''
      this.checkField('coverUrl')
    },
    handleCoverHistory(e) {
      console.log('覆盖历史版本', e.target.checked)
      const value = e.target.checked
      
      if (!this.versionList.length && value) {
        this.$info({
          title: '',
          content: this.$t('project.noVersionAvailable'),
          okText: this.$t('base.confirm'),
          onOk: () => {},
          centered: true
        })
        this.isCoverVersion = false
        return
      }

      if (value) {
        this.$confirm({
          title: '警告提示',
          content: '当前版本已存在!若确认发布,将会替换相应版本',
          okText: '确定',
          cancelText: '取消',
          centered: true,
          onOk: () => {
            this.isCoverVersion = value
            this.isShowHistoryVersion = true
            this.form.coverVersion = this.versionList[this.versionList.length - 1]
          },
          onCancel: () => {
            this.isShowHistoryVersion = false
            this.isCoverVersion = false
          }
        })
      } else {
        // 重置最新版本
        this.form.coverVersion = null
        this.form.version = this.templateInfo.version
        this.isShowHistoryVersion = false
      }
    },
  }
}
</script>

<style lang="less" scoped>
.password-icon {
  width: 16px;
  height: 16px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url('~@/assets/images/password_unsee.png');
  cursor: pointer;

  &.password {
    background-image: url('~@/assets/images/password_see.png');
  }
}

.form {
  ::v-deep .ant-form-item {
    margin-bottom: 16px;
  }

  ::v-deep .ant-form-item-label label::after {
    // display: none;
    content: ' ';
  }

  ::v-deep .ant-form-item-children {
    position: initial;
  }

  ::v-deep .ant-form-item-control {
    line-height: normal;
  }

  ::v-deep .ant-form-item-control:not('has-error') .ant-form-explain {
    display: none;
  }
}

.export-select {
  display: flex;
  flex-direction: row;

  > input {
    margin-right: 8px;
    flex: 1;
  }

  > span {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-image: url('~@/assets/images/output_icon.png');
    cursor: pointer;
  }
}

.password-container {
  color: #fff;

  ::v-deep .ant-form-item-control {
    line-height: 12px;
  }

  .password-show {
    > span {
      margin-right: 16px;
    }
  }
}

.tip_container {
  word-break: break-word;
  font-size: 14px;
  color: #ffffff;
  line-height: 22px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  span {
    transform: translateY(3px);
    display: inline-block;
    width: 20px;
    height: 20px;
    background-size: 100%;
    margin-right: 5px;
    background-repeat: no-repeat;
    background-image: url('~@/assets/images/warn_tips.png');
  }
}

.upload-container {
  margin: 0;
  padding: 0;
  display: flex;
  .upload-item {
    margin: 0;
    padding: 0;
    float: left;

    & + .upload-item {
      margin-left: 20px;
    }
  }

  .upload-item-img {
    margin-right: 20px;
    width: 162px;
    // aspect-ratio: 4 / 3;
    height: 104px;
    position: relative;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.2);

    img {
      width: 100%;
      height: 100%;
      // object-fit: cover;
      border-radius: 4px;
    }

    .anticon {
      position: absolute;
      right: 6px;
      top: 6px;
      font-size: 12px;
      color: #fff;
      background-color: #959aa8;
      padding: 5px;
      border-radius: 50%;

      &:hover {
        background-color: #828eaf;
      }
    }

    .default-cover {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 24px;
      background: #313132;
      font-size: 14px;
      line-height: 24px;
      color: #a3a7b3;
      text-align: center;
    }
  }
  ::v-deep .ant-upload-picture-card-wrapper{
    width: inherit;
    .ant-upload.ant-upload-select-picture-card{
      background-color: #313132;
      margin-bottom: 0;
      margin-right: 0;
      border: none;
      
      & > .ant-upload {
        padding: 0;
      }
    }
  }

  .upload-item-handle {
    box-sizing: border-box;
    width: 102px;
    height: 102px;
    // border: 1px dashed @main-color;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #313132;

    .anticon {
      font-size: 24px;
    }

    &:hover {
      color: #fff;
    }
  }

  .upload-item-tips {
    float: left;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 104px;

    p {
      line-height: 20px;
      color: #fff;
      font-size: 14px;
    }
  }
}

/deep/ .cover-history {
  user-select: none;
  color: #fff;

  label > span:last-of-type {
    color: #fff;
  }

  .ant-checkbox-inner {
    border-radius: 50%;
  }

  .ant-checkbox-wrapper:hover {
    .ant-checkbox-checked::after {
      border: none;
    }
  }
}

.cover-version {
  display: inline-block;
  // width: 200px;
  line-height: 30px;
  color: #f3f3f3;
}

.jf {
  color: #fff;
}

.mask-loading {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  .tip {
    color: #666;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.extra-input {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 5px;
  justify-content: space-between;
}

/deep/ .hy {
  margin-bottom: 0px !important;
}
.m-integral {
  display: flex;
  justify-content: end;
  // flex: 1;
}
.addIconClass {
  color: #FFF;
}
.cancelBtnClass {
  background: #3c3c3f;
  border: 1px solid #3c3c3f;
  color: #fff;
}
</style>
